import { render, staticRenderFns } from "./teacher-detail.vue?vue&type=template&id=5cf25572&scoped=true"
import script from "./teacher-detail.vue?vue&type=script&lang=js"
export * from "./teacher-detail.vue?vue&type=script&lang=js"
import style0 from "./teacher-detail.vue?vue&type=style&index=0&id=5cf25572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf25572",
  null
  
)

export default component.exports